import {  useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { loanService } from '../../services/loanService';

export const useGetLoanList = params => {
  return useQuery({
    staleTime: 1000 * 60 * 60, // 1 hour
    queryKey: [QUERY_KEYS.loan.loan_list, params],
    queryFn: async () => {
      const response = await loanService.loanList(params);
      const { status, data } = response;
      if (status === 200) {
        return data;
      }
      throw new Error('Fetch failed');
    },
  });
};
